import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { isOrganizationScopedFolder } from '@monorepo/shared/utils/documentFolderScope';
import { useSearchParamState } from '@monorepo/shared/hooks/navigation/useSearchParamState';
import React, { useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useDocumentFoldersList } from '../../hooks/useDocumentFoldersList';
import { Page } from '../styled';
import { useDocumentFoldersLink } from '../../hooks/useDocumentFolderLinks';
import { FolderDocumentsHeader } from './FolderDocumentsHeader';
import { FolderDocumentsTable } from './FolderDocumentsTable';

export function FolderDocumentsPage() {
  const { organizationId, folderId } = useParams();
  if (!organizationId || !folderId) {
    throw new Error(
      "FolderDocuments page was rendered with a url that doesn't have organizationId and folderId",
    );
  }

  const { documentFolders, isLoading } = useDocumentFoldersList({
    organizationId,
  });
  const folder = useMemo(
    () => documentFolders?.find((f) => f.id === folderId),
    [documentFolders, folderId],
  );

  const foldersLink = useDocumentFoldersLink();

  const [filter, setFilter] = useSearchParamState<string>('filter');
  const nonNullFilter = filter ?? '';

  if (isLoading) {
    return <Loading />;
  }

  // Org-scoped folders are managed here; site-scoped folders are managed per site.
  if (!folder || !isOrganizationScopedFolder(folder.scope)) {
    return <Navigate to={foldersLink} replace />;
  }

  return (
    <Page>
      <FolderDocumentsHeader
        organizationId={organizationId}
        folder={folder}
        filter={nonNullFilter}
        onSearch={setFilter}
      />
      <FolderDocumentsTable
        organizationId={organizationId}
        folderId={folder.id}
        filter={nonNullFilter}
      />
    </Page>
  );
}
